/**
 * @generated SignedSource<<3ad04f29554ddd571661869282e4d164>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type NoteStreamType = "goalset" | "meeting" | "oneonone" | "personal";
import { FragmentRefs } from "relay-runtime";
export type MoreActionsMenu_MeetingHeader_note$data = {
  readonly eventGuid: string | null;
  readonly hasMeetingRecordings: boolean;
  readonly id: string;
  readonly isLocked: boolean;
  readonly noteType: NoteStreamType;
  readonly stream: {
    readonly id: string;
    readonly type: NoteStreamType;
  };
  readonly title: string;
  readonly viewerCanEdit: boolean;
  readonly " $fragmentSpreads": FragmentRefs<"AddNoteTitle_note" | "ApplyTemplate_note" | "CarryForward_MoreActionsMenu_note" | "DeleteMeeting_note" | "EditLinkedEvent_note" | "EditTemplateMenuItem_note" | "ExportMenuItem_note" | "LockNote_note" | "MergeSeries_note" | "NotAOneOnOne_note" | "RecapLanguage_note" | "ResolvedComments_note" | "SaveAsTemplate_note" | "SeriesSettings_note" | "ShareSeries_note" | "VersionHistory_note" | "useCopyMeetingLink_note">;
  readonly " $fragmentType": "MoreActionsMenu_MeetingHeader_note";
};
export type MoreActionsMenu_MeetingHeader_note$key = {
  readonly " $data"?: MoreActionsMenu_MeetingHeader_note$data;
  readonly " $fragmentSpreads": FragmentRefs<"MoreActionsMenu_MeetingHeader_note">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MoreActionsMenu_MeetingHeader_note",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isLocked",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "viewerCanEdit",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasMeetingRecordings",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "noteType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "eventGuid",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "NoteStream",
      "kind": "LinkedField",
      "name": "stream",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "type",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useCopyMeetingLink_note"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AddNoteTitle_note"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ApplyTemplate_note"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EditTemplateMenuItem_note"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SaveAsTemplate_note"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RecapLanguage_note"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SeriesSettings_note"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CarryForward_MoreActionsMenu_note"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MergeSeries_note"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ExportMenuItem_note"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "VersionHistory_note"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ResolvedComments_note"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EditLinkedEvent_note"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NotAOneOnOne_note"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "LockNote_note"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DeleteMeeting_note"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ShareSeries_note"
    }
  ],
  "type": "Note",
  "abstractKey": null
};
})();

(node as any).hash = "2ec2c2b8b542bb4e3f2d1d28d2a4829c";

export default node;
